import { render, staticRenderFns } from "./AvancesProcesos.vue?vue&type=template&id=e5062eb4"
import script from "./AvancesProcesos.vue?vue&type=script&lang=js"
export * from "./AvancesProcesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports